import { render, staticRenderFns } from "./ChangeClasse.vue?vue&type=template&id=38a5fd83&"
import script from "./ChangeClasse.vue?vue&type=script&lang=js&"
export * from "./ChangeClasse.vue?vue&type=script&lang=js&"
import style0 from "./ChangeClasse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports